import { all, call, put, takeLatest } from "redux-saga/effects";
import * as constants from "../constants/systemsConstants";
import { getAllSystems } from "../../services/systemsService";
export function* systemsGetAll(action) {
  const { token } = action
  try {
    const ans = yield call(getAllSystems, token);
    const data = ans.data
    yield put({ type: constants.SYSTEM_GET_ALL_SUCCEEDED, data });
  } catch (error) {
    yield put({ type: constants.SYSTEM_GET_ALL_FAILED, error });
  }
}

export function* watchSystems() {
  yield all([takeLatest(constants.SYSTEM_GET_ALL_REQUESTED, systemsGetAll)]);
}